export default "__VITE_ASSET__f61a0355__"